/**
 * WorkDocFontSelector — Font family dropdown with web-safe + Google Fonts
 */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FONTS = [
  { group: "Web Safe", fonts: [
    { name: "Arial", value: "Arial" },
    { name: "Times New Roman", value: "Times New Roman" },
    { name: "Courier New", value: "Courier New" },
    { name: "Georgia", value: "Georgia" },
    { name: "Verdana", value: "Verdana" },
    { name: "Calibri", value: "Calibri" },
    { name: "Trebuchet MS", value: "Trebuchet MS" },
    { name: "Tahoma", value: "Tahoma" },
    { name: "Impact", value: "Impact" },
    { name: "Comic Sans MS", value: "Comic Sans MS" },
  ]},
  { group: "Google Fonts", fonts: [
    { name: "Inter", value: "Inter" },
    { name: "Roboto", value: "Roboto" },
    { name: "Open Sans", value: "Open Sans" },
    { name: "Lato", value: "Lato" },
    { name: "Montserrat", value: "Montserrat" },
    { name: "Playfair Display", value: "Playfair Display" },
    { name: "Source Sans Pro", value: "Source Sans Pro" },
    { name: "Poppins", value: "Poppins" },
    { name: "IBM Plex Sans", value: "IBM Plex Sans" },
    { name: "Merriweather", value: "Merriweather" },
  ]},
];

export default function WorkDocFontSelector({ value, onChange, editor }) {
  const currentFont = value || "Arial";

  return (
    <Select value={currentFont} onValueChange={(v) => {
      if (editor) {
        editor.chain().focus().setFontFamily(v).run();
      }
      if (onChange) onChange(v);
    }}>
      <SelectTrigger className="w-40 h-8 text-xs bg-gray-900 border-gray-700 text-white rounded">
        <SelectValue placeholder="Font" />
      </SelectTrigger>
      <SelectContent className="bg-gray-900 border-gray-700 text-white max-h-64">
        {FONTS.map((group) => (
          <div key={group.group}>
            <div className="px-2 py-1 text-[10px] uppercase font-bold tracking-wider text-gray-500 sticky top-0 bg-gray-900 z-10">
              {group.group}
            </div>
            {group.fonts.map((f) => (
              <SelectItem key={f.value} value={f.value} className="text-sm" style={{ fontFamily: f.value }}>
                {f.name}
              </SelectItem>
            ))}
          </div>
        ))}
      </SelectContent>
    </Select>
  );
}
